<template>
  <span
    v-if="!filterShow"
    @click="labelClicked"
    @dblclick="doubleClicked"
    @contextmenu.prevent="contextClicked"
    :class="classes"
    :style="style"
  >{{customLabel ||obj.name}}</span>
  <div v-else>
    <a href="#" @click="filterClicked" class="filtershow-margin-right">
      <img :src="filter ? 'images/icons_sw_f_aktiv.png' : 'images/icons_sw_f.png'" />
    </a>
    <a href="#" @click="showClicked">
      <img :src="show ? 'images/icons_sw_a_aktiv.png' : 'images/icons_sw_a.png'" />
    </a>
    <span
      @click="labelClicked"
      @dblclick="doubleClicked"
      @contextmenu.prevent="contextClicked"
      :class="classes"
      :style="Object.assign(style, {display: 'inline'})"
    >{{customLabel ||obj.name}}</span>
  </div>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    obj: {
      type: Object,
      required: true
    },
    singleSelect: {
      type: Boolean,
      default() {
        return false;
      }
    },
    width: {
      type: String,
      default() {
        return "300px";
      }
    },
    customLabel: {
      type: String
    },
    /*
     * Indicates if this assignmentbox should use filter and show icons
     */
    filterShow: {
      type: Boolean,
      default() {
        return false;
      }
    },
    filter: {
      type: Boolean,
      default() {
        return false;
      }
    },
    show: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    classes() {
      return {
        pointer: true,
        listitemselected: this.clicked
      };
    },
    style() {
      return {
        width: this.width,
        "padding-left": "2px",
        "padding-right": "2px"
      };
    }
  },
  methods: {
    contextClicked(clickevent) {
      if (!this.clickable) {
        return;
      }
      this.$log.debug("Clickevent", clickevent);
      this.clicked = !this.clicked;
      this.$emit("contextClicked", {
        active: this.clicked,
        obj: this.obj,
        clickevent
      });
      if (this.singleSelect) {
        this.$util.eventbus.$emit("singleSelect", this);
      }
    },
    doubleClicked() {
      if (!this.clickable) {
        return;
      }
      this.$emit("doubleClicked", { active: this.clicked, obj: this.obj });
    },
    filterClicked() {
      this.$emit("filterClicked");
    },
    showClicked() {
      this.$emit("showClicked");
    },
    labelClicked() {
      if (!this.clickable) {
        return;
      }
      this.clicked = !this.clicked;
      this.$emit("labelClicked", { active: this.clicked, obj: this.obj });
      if (this.singleSelect) {
        this.$util.eventbus.$emit("singleSelect", this);
      }
    },
    setLabelState(state = false) {
      this.clicked = state;
    },
    handleSingleSelectAction(obj) {
      if (obj !== this) {
        this.clicked = false;
      }
    }
  },
  mounted() {
    this.$util.eventbus.$on("singleSelect", this.handleSingleSelectAction);
  },
  beforeDestroy() {
    this.$util.eventbus.$off("singleSelect", this.handleSingleSelectAction);
  }
};
</script>

<style scoped>
.pointer {
  user-select: none;
  cursor: pointer;
}

.highlight {
  color: #7aa9f4;
}

.listitemselected {
  background-color: #439dc8;
  color: #fff;
  display: block;
}

.filtershow-margin-right {
  margin-right: 3px;
}
</style>

